import React from "react";
import OurMission from "../../../images/about-us/OurMission-Icon.png";
import OurStory from "../../../images/about-us/OurStory-Icon.png";
import OurVision from "../../../images/about-us/OurVision-Icon.png";
import NcImage from "shared/NcImage/NcImage";

type Goals = {
  backgroundColor: string;
  titleColor?: string;
  title: string;
  message: string;
  titleImage: string;
};

const goals: Goals[] = [
  {
    backgroundColor: "bg-csccolor text-white",
    title: "Our Story",
    titleImage: OurStory,
    message: `CSC LED started in a small Ontario warehouse in
              2005 with a clear goal: to bring better lighting options
              to the Canadian market. What began as a modest
              operation has since grown into a nationwide brand,
              built on hard work, strong relationships, and a deep
              understanding of the electrical wholesale industry.`,
  },
  {
    backgroundColor: "bg-stone-100",
    titleColor: "text-csccolor",
    titleImage: OurMission,
    title: "Our Mission",
    message: `To support our partners with unmatched customer service,
              fast response times, and dependable communication. We’re 
              here to make their jobs easier by offering expert guidance,
              real-time problem solving, and a team that treats every
              project like it matters, because to us, it does.`,
  },
  {
    backgroundColor: "bg-csccolor text-white",
    title: "Our Vision",
    titleImage: OurVision,
    message: `We strive to be the most dependable and service-focused 
              partner our customers work with. By delivering consistent, 
              knowledgeable support and a hassle-free experience, we aim 
              to set the standard for customer service in the commercial and 
              industrial LED industry.`,
  },
];

const AboutUsGoals = () => {
  return (
    <div className="nc-AboutUsGoals w-full grid grid-row-3 sm:grid-cols-3 gap-0 pt-12">
      {goals.map((goal, idx) => (
        <div
          key={idx}
          className={`${goal.backgroundColor} p-10 flex flex-col items-center justify-center text-center space-y-5`}
        >
          <NcImage
            containerClassName="w-20 h-20"
            className="object-contain w-full h-full"
            src={goal.titleImage}
          />
          <div className={`text-2xl font-bold ${goal?.titleColor}`}>
            {goal.title}
          </div>
          <div className="">{goal.message}</div>
        </div>
      ))}
    </div>
  );
};

export default AboutUsGoals;
